import { Image } from '@components/Image';
import useStyles from './useStyles';
import DefaultDrawingFileImage from './default_drawing_file.png';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { ChevronRightOutlined } from '@material-ui/icons';
import Avatars from './Avatars.png';
import {
  CapaQuotationServiceType,
  CapaRfqAvailableReviews
} from '@generated/graphql';
import { formatDate } from '@utils/formatter';
import { getFileUrl } from '@utils/urls';
import { useHistory } from 'react-router-dom';
import useReview from '@hooks/useReview';
import { clsx } from '@components/Provider';
import AppConfig from '@config';

interface Props {
  gutterBottom: boolean;
  reviewInfo?: CapaRfqAvailableReviews;
}

const WriteableReviewListItem = ({ gutterBottom, reviewInfo }: Props) => {
  const classes = useStyles();
  const history = useHistory();
  const reviews = reviewInfo?.reviews ?? [];
  const rfqId = reviewInfo?.rfqId ?? '';
  const serviceType = reviewInfo?.serviceType ?? undefined;
  const isDesign = serviceType === CapaQuotationServiceType.Design;

  const thumbnail = isDesign
    ? `${AppConfig.fileApiUrl}/file/${reviewInfo?.thumbnailId}`
    : `${AppConfig.hoopsViewerAPI}/${reviewInfo?.thumbnailId}.png`;

  const { onUpdateReview } = useReview();

  const go = (path?: string) => {
    if (path) return history.push(path);
  };

  return (
    <div
      className={clsx(classes.item, {
        'gutter-bottom': gutterBottom
      })}
    >
      <div className={classes.itemProject}>
        <Image
          className="thumbnail"
          src={thumbnail}
          onError={(e) => (e.currentTarget.src = DefaultDrawingFileImage)}
        />
        <div
          className="project"
          onClick={() => go(`/dashboard/${reviewInfo?.rfqId}`)}
        >
          <CustomizedTypography
            className="name"
            variant="subtitle1"
            color="textPrimary"
            fontWeight="bold"
            gutterBottoms={2}
          >
            {reviewInfo?.projectName}
            <ChevronRightOutlined />
          </CustomizedTypography>
          <CustomizedTypography variant="subtitle2" color="textSecondary">
            요청 등록&nbsp;
            {reviewInfo?.rfqCreatedAt &&
              formatDate(reviewInfo?.rfqCreatedAt, 'YY.MM.DD')}
          </CustomizedTypography>
        </div>
      </div>

      {reviews.map((review, index) => (
        <div
          key={review?.purchaseOrderCreatedAt}
          className={classes.itemPartner}
        >
          <div className="partner">
            <Image
              className="thumbnail avatar"
              alt=""
              src={getFileUrl(review.profileId ?? '')}
              onError={(e) => (e.currentTarget.src = Avatars)}
            />

            <div className="project">
              <CustomizedTypography
                className="name"
                variant="body1"
                color="textPrimary"
                fontWeight="500"
                gutterBottoms={2}
                onClick={() => go(`/chat/${review.chatRoomId}`)}
              >
                <span className="chip">발주완료</span>&nbsp;
                {review.organizationName}&nbsp;
                <ChevronRightOutlined />
              </CustomizedTypography>
              <CustomizedTypography variant="subtitle2" color="textPrimary">
                발주 완료일:&nbsp;
                {review?.purchaseOrderCreatedAt &&
                  formatDate(review?.purchaseOrderCreatedAt, 'YYYY.MM.DD')}
              </CustomizedTypography>
            </div>
          </div>

          <CustomizedButton
            variant="outlined"
            color="primary"
            size="small"
            className={classes.cta}
            onClick={() => {
              onUpdateReview({
                open: true,
                rfqId,
                quotationPartnerId: review.quotationPartnerId,
                profileId: review.profileId ?? '',
                reviewId: '',
                projectName: reviewInfo?.projectName ?? '',
                organizationName: review?.organizationName ?? ''
              });
            }}
          >
            리뷰 작성하기
          </CustomizedButton>
        </div>
      ))}
    </div>
  );
};

export default WriteableReviewListItem;
